'use client';
import { App } from '@web/query/App';
import { Search } from '@web/store/Search';
function Filters() {
  const getSource = Search.useFilter(({ source }) => source);
  const isCoreFilters = getSource === 'core-filters';
  App.useFilters(isCoreFilters);

  return null;
}

export { Filters };
